var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 15,
    r: 2.5,
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6528 20.52V24.48M19.6528 24.48C18.939 24.48 17.4257 23.952 17.083 21.84C16.6547 19.2 17.9396 17 19.6528 17C21.366 17 22.2224 17.88 23.9356 17.88C25.2205 17.88 26.9789 16.2593 27.362 17.4399C27.7903 18.7599 29.5035 23.16 29.9318 24.48C30.3601 25.8 28.6469 26.68 28.2186 25.36C27.7719 23.9831 27.2193 22.1333 26.9337 21.4C26.9337 26.5333 26.9337 36.976 26.9337 37.68C26.9337 38.56 26.5054 39 26.0771 39C25.6488 39 24.7922 39 24.7922 37.68V30.2H21.7941C21.7941 31.52 21.7941 34.512 21.7941 35.92C21.7941 37.68 22.2222 39 20.9375 39C19.6528 39 19.6528 37.24 19.6528 35.92C19.6528 34.864 19.6528 27.8533 19.6528 24.48Z",
    stroke: "#183883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37C32 34.36 32 28.816 32 27.76C32 25.56 29 25.12 29 28.2",
    stroke: "#183883"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNps);
export default __webpack_public_path__ + "static/media/NPS.4eb44715912dd99815d82acb7762be73.svg";
export { ForwardRef as ReactComponent };